import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {TokenDataProviderService} from "../services/token-data-provider.service";
import {ResponseNotificationService} from "../services/response-notification.service";
import {TranslateService} from "@ngx-translate/core";
import {JwtService} from "../services/jwt.service";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private readonly router: Router,
    private readonly ts: TokenDataProviderService,
    private readonly jwt: JwtService,
    private readonly rns: ResponseNotificationService,
    private readonly translate: TranslateService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.ts.isLoggedIn()) {
      return true;
    }

    if (this.ts.isLoggedWithRememberOption()) {
      return this.jwt.refreshJwtToken().pipe(
        map(() => true),
        catchError(error => {
          if (error.status === 400 || error.status === 401) {
            this.rns.emitError(this.translate.instant('app.error.api_token_expired'));
            this.router.navigate(['/landing']);
          }
          return of(false);
        })
      );
    }

    this.ts.logout(true);
    this.router.navigate(['/landing']);

    // this.ts.logout(true);
    // this.router.navigate(['/landing']);

    return false;
  }
}
